
<router-outlet></router-outlet>
<app-guided-tour-overlay></app-guided-tour-overlay>
<div id="notifications-container"></div>